import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ef15ba9c")

_pushScopeId("data-v-ef15ba9c")
const _hoisted_1 = {
  key: 0,
  class: "flex align-center"
}
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "flex margin-bottom-5" }
const _hoisted_4 = { class: "flex align-center" }
const _hoisted_5 = { class: "margin-left-10" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("循环播放")
const _hoisted_7 = { class: "flex margin-top-5" }
const _hoisted_8 = { class: "flex-center margin-top-10" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_time_select = _resolveComponent("el-time-select")
  const _component_el_popover = _resolveComponent("el-popover")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")
  const _component_el_timeline = _resolveComponent("el-timeline")
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createBlock(_component_el_drawer, {
    title: "设置时间段",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = $event)),
    direction: "rtl",
    width: "40%"
  }, {
    default: _withId(() => [
      _createVNode(_component_el_timeline, { class: "timeline" }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timeBoxes, (timeBox, index) => {
            return (_openBlock(), _createBlock(_component_el_timeline_item, {
              placement: "top",
              key: index,
              timestamp: timeBox.startTime
            }, {
              default: _withId(() => [
                (index < _ctx.timeBoxes.length - 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_1, [
                      _createVNode("div", _hoisted_2, [
                        _createVNode(_component_el_popover, {
                          placement: "left",
                          width: 200,
                          trigger: "click"
                        }, {
                          reference: _withId(() => [
                            _createVNode("div", _hoisted_3, [
                              _createVNode(_component_el_button, {
                                size: "mini",
                                circle: "",
                                type: "success",
                                icon: "el-icon-plus",
                                onClick: ($event: any) => (_ctx.setCurrentTimeBox(index, timeBox))
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          default: _withId(() => [
                            _createVNode(_component_el_time_select, {
                              start: _ctx.calcTimePoint(timeBox.startTime, 30),
                              onChange: _ctx.addTimeBoxAbove,
                              step: "00:30",
                              end: _ctx.calcTimePoint(timeBox.endTime, -30),
                              placeholder: "选择分割点"
                            }, null, 8, ["start", "onChange", "end"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode("div", _hoisted_4, [
                          _createVNode(_component_el_input, {
                            class: {'name': true, 'empty': timeBox.name === ''},
                            size: "mini",
                            modelValue: timeBox.name,
                            "onUpdate:modelValue": ($event: any) => (timeBox.name = $event)
                          }, null, 8, ["class", "modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_el_switch, {
                            modelValue: timeBox.visualMode,
                            "onUpdate:modelValue": ($event: any) => (timeBox.visualMode = $event),
                            "active-color": "black",
                            "inactive-color": "lavender",
                            "active-value": "DARK",
                            "inactive-value": "LIGHT",
                            "active-text": "深色",
                            "inactive-text": "浅色"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode("div", _hoisted_5, [
                            _createVNode(_component_el_checkbox, {
                              modelValue: timeBox.loopPlayback,
                              "onUpdate:modelValue": ($event: any) => (timeBox.loopPlayback = $event)
                            }, {
                              default: _withId(() => [
                                _hoisted_6
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]),
                        _createVNode(_component_el_popover, {
                          placement: "left",
                          width: 200,
                          trigger: "click"
                        }, {
                          reference: _withId(() => [
                            _createVNode("div", _hoisted_7, [
                              _createVNode(_component_el_button, {
                                size: "mini",
                                circle: "",
                                type: "success",
                                icon: "el-icon-plus",
                                onClick: ($event: any) => (_ctx.setCurrentTimeBox(index, timeBox))
                              }, null, 8, ["onClick"])
                            ])
                          ]),
                          default: _withId(() => [
                            _createVNode(_component_el_time_select, {
                              start: _ctx.calcTimePoint(timeBox.startTime, 30),
                              onChange: _ctx.addTimeBoxBelow,
                              step: "00:30",
                              end: _ctx.calcTimePoint(timeBox.endTime, -30),
                              placeholder: "选择分割点"
                            }, null, 8, ["start", "onChange", "end"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      (_ctx.timeBoxes.length > 2)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            class: "margin-left-5",
                            size: "mini",
                            circle: "",
                            type: "danger",
                            icon: "el-icon-minus",
                            onClick: ($event: any) => (_ctx.removeTimeBox(index, timeBox))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["timestamp"]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.submit
        }, {
          default: _withId(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
          default: _withId(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
})